import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

export const routes: any[] = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login.vue')
  },
  {
    path: '/',
    redirect: '/authority/userMgr'
  },
  {
    path: '/redirectURL',
    component: () => import('@/views/layout/layout.vue'),
    children: [
      {
        path: '',
        name: 'redirectURL',
        component: () => import('@/views/layout/redirect.vue')
      }
    ]
  },
  // 权限管理
  {
    path: '/authority',
    redirect: '/authority/userMgr',
    component: () => import('@/views/layout/layout.vue'),
    name: 'authority',
    meta: { title: '权限管理', icon: 'icon-menu-customer' },
    children: [{
      path: 'userMgr',
      name: 'userMgr',
      component: () => import('@/views/authorityMgr/userMgr/list/list.vue'),
      meta: { title: '用户管理', icon: 'userMgr', name: 'userMgr', }
    },
    {
      path: 'roleMgr',
      name: 'roleMgr',
      component: () => import('@/views/authorityMgr/roleMgr/list/list.vue'),
      meta: { title: '角色管理', icon: 'roleMgr', name: 'roleMgr', }

    },
    {
      path: 'orgMgr',
      name: 'orgMgr',
      component: () => import('@/views/authorityMgr/orgMgr/list/list.vue'),
      meta: { title: '机构管理', icon: 'orgMgr', name: 'orgMgr', }
    }]
  },
  {
    path: '/resourceMgr',
    redirect: '/resourceMgr/onlineResourceMgr',
    component: () => import('@/views/layout/layout.vue'),
    name: 'resourceMgr',
    meta: { title: '资源管理', icon: 'icon-menu-directory' },
    children: [{
      path: 'onlineResourceMgr',
      name: 'onlineResourceMgr',
      component: () => import('@/views/resourceMgr/onlineResourceMgr/list/list.vue'),
      meta: { title: '线上资源管理', icon: 'onlineResourceMgr' , name: 'onlineResourceMgr', },
      children: [
        {
          path: 'detail/:id',
          name: 'onlineResDetail',
          component: () => import('@/views/resourceMgr/onlineResourceMgr/detail/detail.vue'),
          meta: { title: '线上资源详情', icon: 'onlineResDetail', name: 'onlineResDetail', }
        },
        {
          path: '/record',
          name: 'onlineRecord',
          component: () => import('@/views/resourceMgr/onlineResourceMgr/record/record.vue'),
          meta: { title: '操作记录', icon: 'record', name: 'onlineRecord' }
        }
      ]
    },
    {
      path: 'offlineResourceMgr',
      name: 'offlineResourceMgr',
      component: () => import('@/views/resourceMgr/offlineResourceMgr/list/list.vue'),
      meta: { title: '线下资源管理', icon: 'offlineResourceMgr', name: 'offlineResourceMgr'},
      children: [
          {
          path: 'detail/:id',
          name: 'offlineResDetail',
          component: () => import('@/views/resourceMgr/offlineResourceMgr/detail/detail.vue'),
          meta: { title: '线下资源详情', icon: 'offlineResDetail', name: 'offlineResDetail', }
        },
        {
          path: '/record',
          name: 'offlineRecord',
          component: () => import('@/views/resourceMgr/offlineResourceMgr/record/record.vue'),
          meta: { title: '操作记录', icon: 'record', name: 'offlineRecord' }
        }
      ]
    }]
  }
];
export const routesComputed = routes.filter(v => v.meta);

const router = new VueRouter({ base: process.env.BASE_URL, routes });

export default router;
